export { ServicingPage } from './lib/servicing-page'
export { getStaticProps } from './lib/get-static-props'
